import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_BEACHTENNIS } from 'src/app/core/constants';

@Component({
    selector: 'app-beachtennis-attached',
    templateUrl: './beachtennis-attached.component.html',
    styleUrls: ['./beachtennis-attached.component.scss'],
})
export class BeachtennisAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Beach tennis
     */
    public departmentType: string = DEPARTMENT_TYPE_BEACHTENNIS;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
